import { styled } from '@mui/material/styles';

export const ListItemHeader = styled('strong')`
  display: block;
  font-weight: 600;
  text-transform: uppercase;
`;
